<template>
  <d2-container>
    <template slot="header">
      <div class="app-container calendar-list-container">
        <div class="filter-container">
          <el-input size="small" @keyup.enter.native="handleFilter" style="width: 200px;margin-right: 10px;"
            class="filter-item" placeholder="姓名或账户" v-model="listQuery.name"> </el-input>
          <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">搜索</el-button>
          <el-button size="small" class="filter-item" v-permission:function="['czBankInfoManager_btn_add']"
            style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">添加</el-button>
        </div>
      </div>
    </template>

    <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row
      style="width: 100%">

      <el-table-column align="center" label="id" width="65">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="银行名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="统一社会信用代码 ">
        <template slot-scope="scope">
          <span>{{ scope.row.socialCreditCode }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="法人/负责人">
        <template slot-scope="scope">
          <span>{{ scope.row.legalRepresentative }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="负责人身份证">
        <template slot-scope="scope">
          <span>{{ scope.row.legalRepresentativeIdCard }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="职务">
        <template slot-scope="scope">
          <span>{{ scope.row.post }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="公司所在地">
        <template slot-scope="scope">
          <span>{{ scope.row.address }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="送达地址">
        <template slot-scope="scope">
          <span>{{ scope.row.serviceAddress }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="联系方式">
        <template slot-scope="scope">
          <span>{{ scope.row.contact }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="创建人">
        <template slot-scope="scope">
          <span>{{ scope.row.founder }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="修改人">
        <template slot-scope="scope">
          <span>{{ scope.row.operator }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="修改时间">
        <template slot-scope="scope">
          <span>{{ scope.row.editTime }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="150"> <template slot-scope="scope">
          <el-button v-permission:function="['czBankInfoManager_btn_edit']" size="small" type="success"
            @click="handleUpdate(scope.row)">编辑
          </el-button>
          <el-button v-permission:function="['czBankInfoManager_btn_del']" size="small" type="danger"
            @click="handleDelete(scope.row)">删除
          </el-button>
        </template> </el-table-column>
    </el-table>
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
      </div>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px">
        <el-form-item label="银行名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入银行名称"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码 " prop="socialCreditCode">
          <el-input v-model="form.socialCreditCode" placeholder="请输入统一社会信用代码 "></el-input>
        </el-form-item>
        <el-form-item label="法人/负责人" prop="legalRepresentative">
          <el-input v-model="form.legalRepresentative" placeholder="请输入法人/负责人"></el-input>
        </el-form-item>
        <el-form-item label="负责人身份证" prop="legalRepresentativeIdCard">
          <el-input v-model="form.legalRepresentativeIdCard" placeholder="请输入负责人身份证"></el-input>
        </el-form-item>
        <el-form-item label="职务" prop="post">
          <el-input v-model="form.post" placeholder="请输入职务"></el-input>
        </el-form-item>
        <el-form-item label="公司所在地" prop="address">
          <el-input v-model="form.address" placeholder="请输入公司所在地"></el-input>
        </el-form-item>
        <el-form-item label="送达地址" prop="serviceAddress">
          <el-input v-model="form.serviceAddress" placeholder="请输入送达地址"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="form.contact" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')" size="small">取 消</el-button>
        <el-button v-if="dialogStatus == 'create'" size="small" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" size="small" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  page,
  addObj,
  getObj,
  delObj,
  putObj
} from '@/api/czManager/czBankInfo/index';
import { mapGetters } from 'vuex';
export default {
  name: 'czBankInfo',
  data() {
    return {
      form: {
        name: undefined, socialCreditCode: undefined, legalRepresentative: undefined,legalRepresentativeIdCard:undefined, post: undefined, address: undefined, serviceAddress: undefined, contact: undefined, founder: undefined, createTime: undefined, email: undefined, editTime: undefined
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入银行名称',
            trigger: 'blur'
          }
        ], socialCreditCode: [
          {
            required: true,
            message: '请输入统一社会信用代码 ',
            trigger: 'blur'
          }
        ], legalRepresentative: [
          {
            required: true,
            message: '请输入法人/负责人',
            trigger: 'blur'
          }
        ], legalRepresentativeIdCard:[
          {
            required: true,
            message: '请输入负责人身份证号',
            trigger: 'blur'
          }
        ], post: [
          {
            required: true,
            message: '请输入职务',
            trigger: 'blur'
          }
        ], address: [
          {
            required: true,
            message: '请输入公司所在地',
            trigger: 'blur'
          }
        ], serviceAddress: [
          {
            required: true,
            message: '请输入送达地址',
            trigger: 'blur'
          }
        ], contact: [
          {
            required: true,
            message: '请输入联系方式',
            trigger: 'blur'
          }
        ]
      },
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      tableKey: 0
    }
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters([
      'elements'
    ])
  },
  methods: {
    getList() {
      this.listLoading = true;
      page(this.listQuery).then(response => {
        this.list = response.rows;
        this.total = response.total;
        this.listLoading = false;
      })
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
    },
    handleUpdate(row) {
      getObj(row.id)
        .then(response => {
          this.form = response;
          this.dialogFormVisible = true;
          this.dialogStatus = 'update';
        });
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delObj(row.id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success',
                duration: 2000
              });
              const index = this.list.indexOf(row);
              this.list.splice(index, 1);
            });
        });
    },
    create(formName) {
      const set = this.$refs;
      set[formName].validate(valid => {
        if (valid) {
          addObj(this.form)
            .then(() => {
              this.dialogFormVisible = false;
              this.getList();
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              });
            })
        } else {
          return false;
        }
      });
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      const set = this.$refs;
      set[formName].resetFields();
    },
    update(formName) {
      const set = this.$refs;
      set[formName].validate(valid => {
        if (valid) {
          this.dialogFormVisible = false;
          this.form.password = undefined;
          putObj(this.form.id, this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            });
          });
        } else {
          return false;
        }
      });
    },
    resetTemp() {
      this.form = {
        username: undefined,
        name: undefined,
        sex: '男',
        password: undefined,
        description: undefined
      };
    }
  }
}
</script>
